// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__bi6x0"};